module.exports = __webpack_public_path__ + "front/img/content3_wechat.eb3ec645.png";